// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2KvXo","author":"Table_author__2wjIG","authorImage":"Table_authorImage__9NkYa","unreadRow":"Table_unreadRow__2XNtO"};